import swal from 'sweetalert2'

export async function customConfirm(title: string, text?: string) {
    const swalBootstrap = swal.mixin({
        customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
    });

    const result = await swalBootstrap.fire({
        title: title,
        text: text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        reverseButtons: true
    })

    if (result.isConfirmed) return true
    return false
}